@let cta = ctaConfig();
<pm-dialog
  dialogTitle="ANALYSIS.CREATE_CONFIGURATION.TITLE"
  [size]="'md'"
  [optionalCtaConfig]="cta.optional"
  [primaryCtaButtonConfig]="cta.primary"
  [secondaryCtaButtonConfig]="cta.secondary"
>
  <section class="relative">
    @let stepId = this.stepId();

    @switch (stepId) {
      @case ('general') {
        <pm-general-step-analysis-configuration
          (dataChange)="this.updateDto('general', $event)"
          (validChange)="this.stepIsValid.set($event)"
          [initData]="dto().general"
        />
      }
      @case ('hierarchy') {
        <pm-hierarchy-step-analysis-configuration
          (dataChange)="this.updateDto('hierarchy', $event)"
          (validChange)="this.stepIsValid.set($event)"
          [initData]="dto().hierarchy"
        />
      }
      @case ('errorMeasures') {
        <pm-error-measures-step-analysis-configuration
          (dataChange)="this.updateDto('errorMeasures', $event)"
          (validChange)="this.stepIsValid.set($event)"
          [initData]="dto().errorMeasures"
          [consensusEvaluated]="consensusEvaluated()"
        />
      }
      @case ('summary') {
        @let current = dto();
        @if (current.general && current.hierarchy && current.errorMeasures) {
          <pm-summary-step-analysis-configuration
            (validChange)="this.stepIsValid.set($event)"
            [general]="current.general"
            [hierarchy]="current.hierarchy"
            [errorMeasures]="current.errorMeasures"
            [consensusEvaluated]="consensusEvaluated()"
          />
        }
      }
    }
  </section>
</pm-dialog>
